<div bsModal #staticModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-static"
    [config]="{backdrop: 'static'}" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <div class="modal-header">
                <h4 id="dialog-static" class="modal-title pull-left">
                    Connected App: {{propertyName}}
                </h4>
                <button type="button" class="close pull-right" (click)="closeModal()" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body">

                <div class="tabs">
                    <ul class="nav nav-tabs">
                      <li class="nav-item">
                        <a class="nav-link" [class.active]="!showConfig" (click)="showConfigTab(false)">Status</a>
                      </li>  
                      <li class="nav-item">
                        <a class="nav-link" [class.active]="showConfig" (click)="showConfigTab(true)">Configuration</a>
                      </li>
                    </ul>
                </div>

                <div [ngStyle]="{'display': showConfig ? 'none' : 'block'}">
                    <h4>Status Information</h4>
                    
                    <!--This is only used because I can't figure out how to get the display to work properly. once you click the modal, everything displays correctly. so click this button and tada! -->
                    <button class="btn btn-primary margin-top-20" [hidden]="showStatusDetail" (click)="showStatusDetail = true">Get Status</button>
                    
                    <div class="tab-content" *ngIf="showStatusDetail">
                      <div class="text-muted italic margin-bottom-20">{{propertyId}}</div>
                      
                      <div *ngIf="integrationProperty == null">
                        No integration configured.
                      </div>

                      <ng-container *ngIf="integrationProperty && integrationStatus">
                        <div  class="row top-buffer-20">
                            <div class="col-md-3">
                                Is Active
                            </div>
                            <div class="col-md-6">
                                {{integrationStatus.isActive == true ? 'Yes' : 'No'}}
                            </div>
                        </div>
                        <div  class="row top-buffer-20">
                          <div class="col-md-3">
                              Last Updated
                          </div>
                          <div class="col-md-6">
                              {{integrationStatus.lastUpdateDate | date:'medium'}}
                          </div>
                      </div>
      
                        <div class="row top-buffer-20">
                            <div class="col-md-3">
                                Update Status
                            </div>
                            <div class="col-md-6">
                                {{integrationStatus.lastUpdateStatus === 1 ? 'In Progress' : 
                                  integrationStatus.lastUpdateStatus === 2 ? 'Successful' :
                                  integrationStatus.lastUpdateStatus === 3 ? 'Failed' : 'Unknown'}}
                            </div>
                        </div>
                        <div  class="row top-buffer-20">
                          <div class="col-md-3">
                              Number of GL Codes Configured
                          </div>
                          <div class="col-md-6">
                              {{integrationStatus.configuredGlCount}}
                          </div>
                      </div>

                        <div class="margin-top-20 margin-bottom-20">
                          <button class="btn btn-sm btn-warning" (click)="syncIntegration()">Sync Now</button>
                          <button class="btn btn-sm btn-warning margin-left-20" [disabled]="integrationStatus.lastUpdateStatus !== 2" (click)="resetGlCodesByRules()">Reset GL Codes By Rules</button>
                        </div>
                      </ng-container>
                    </div>
                </div>

                <div [ngStyle]="{'display': showConfig ? 'block' : 'none'}">
                    <h4>Integration Configuration</h4>
                    <div class="tab-content">
                      <form [formGroup]="formGroup" autocomplete="off">
                        <div class="row top-buffer-20">
                            <div class="col-md-3">
                                <label class="margin-top-20">Integration / App <i
                                        class="fa fa-asterisk required"></i></label>
                            </div>
                            <div class="col-md-6">
                                <select type="text" placeholder="Category Name" class="sp-select form-control" formControlName="integrationId" name="integrationId">
                                  <option [ngValue]="null">-- Select Integration--</option>
                                  <option *ngFor="let item of integrations | orderBy: 'name'" [ngValue]="item.integrationId">
                                    {{item.name}}
                                  </option>
                                </select>
                            </div>
                        </div>

                        <div class="row top-buffer-20">
                            <div class="col-md-3">
                                <label class="margin-top-20">API Credentials <i
                                        class="fa fa-asterisk required"></i></label>
                            </div>
                            <div class="col-md-6">
                              <select class="sp-select form-control" formControlName="integrationCredentialId" name="integrationCredentialId" (ngModelChange)="onCredentialChange($event)">
                                <option [ngValue]="null">-- Select Credential--</option>
                                <option *ngFor="let item of integrationCredentials | orderBy: 'name'" [ngValue]="item.integrationCredentialId">
                                  {{item.name}}
                                </option>
                              </select>
                              <div class="text-end" *ngIf="integrationId">
                                <button type="button" class="btn btn-link" (click)="toggleAddCredential()">Add New Credential</button>
                              </div>
                            </div>
                        </div>

                        <div class="row top-buffer-20 " *ngIf="showAddCredential">
                          <div class="col-md-3"></div>
                          <div class="col-md-8 add-credential-container">
                            <sp-add-connected-app-credential
                              [integrationId]="integrationId"
                              (addCredential)="onAddCredential($event)"
                              (cancel)="onCancelAddCredential()"
                            ></sp-add-connected-app-credential>
                          </div>
                        </div>

                        <div class="row top-buffer-20">
                          <div class="col-md-3">
                              <label class="margin-top-20">Association ID/Code <i
                                      class="fa fa-asterisk required"></i></label>
                          </div>
                          <div class="col-md-6">
                              <input type="text" placeholder="Association ID/Code" class="form-control" name="externalPropertyCode"
                                  formControlName="externalPropertyCode" />
                              <div class="text-end" *ngIf="showDownloadAssociations">
                                <button type="button" class="btn btn-link" (click)="onDownloadAssociationList()">Download association list</button>
                              </div>
                          </div>
                      </div>                   
                    </form>
                    </div>
                </div>
                
            </div>

            <footer class="text-start">
                <button type="button" class="btn btn-cancel" (click)="closeModal()">Cancel</button>
                <button type="button" class="btn btn-success" [disabled]="!formGroup?.valid || !enableSave()"
                    (click)="save()">Save</button>
            </footer>
        </div>
    </div>
</div>